
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flu-vaccine/book-online",
      function () {
        return require("private-next-pages/flu-vaccine/book-online/index.tsx");
      }
    ]);
  